module.exports = __webpack_public_path__ + "img/up.c477fb47.png";